import React, { Fragment } from 'react';
import { Field } from 'redux-form';
import PropType from 'prop-types';
import renderField from '../../../shared/components/form/RenderField';
import { cellPhoneMasker } from '../../../shared/components/form/Masks';
import Select from '../../../shared/components/form/Select';

export default function MedicalInfo(props) {
  const { t } = props;
  const bloodTypes = [
    { value: 'N.I', label: 'N.I' },
    { value: 'A+', label: 'A+' },
    { value: 'A-', label: 'A-' },
    { value: 'B+', label: 'B+' },
    { value: 'B-', label: 'B-' },
    { value: 'O+', label: 'O+' },
    { value: 'O-', label: 'O-' },
    { value: 'AB+', label: 'AB+' },
    { value: 'AB-', label: 'AB-' },
  ];
  return (
    <Fragment>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.blood-type')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="bloodType"
            type="text"
            component={Select}
            options={bloodTypes}
            placeholder={t('placeholder.student.blood-type')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.health-problems')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="healthIssues"
            type="text"
            component="textarea"
            maxLength="500"
            placeholder={t('placeholder.student.health-problems')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.especial-cares')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="specialCares"
            type="text"
            component="textarea"
            maxLength="500"
            placeholder={t('placeholder.student.especial-cares')}
          />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.allergies-reactions')}
        </span>
        <div className="form__form-group-field">
          <Field
            name="allergies"
            type="text"
            component="textarea"
            maxLength="500"
            placeholder={t('placeholder.student.allergies-reactions')}
          />
        </div>
      </div>
      <div className="form__form-group--2_columns">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.sus-number')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="susNumber"
              type="number"
              component={renderField}
              maxLength="15"
              placeholder={t('placeholder.student.sus-number')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.health-plan-number')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="healthPlanNumber"
              type="text"
              component={renderField}
              maxLength="25"
              placeholder={t('placeholder.student.health-plan-number')}
            />
          </div>
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.health-plan-operator')}
        </span>
        <div className="form_form-group-field">
          <Field
            name="healthPlanOperator"
            type="text"
            component={renderField}
            maxLength="100"
            placeholder={t('placeholder.student.health-plan-operator')}
          />
        </div>
      </div>
      <div className="form__form-group--2_columns">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.pediatrician-name')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="pediatricianName"
              type="text"
              component={renderField}
              maxLength="100"
              placeholder={t('placeholder.student.pediatrician-name')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.pediatrician-phone')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="pediatricianPhone"
              type="text"
              component={renderField}
              {...cellPhoneMasker()}
              placeholder={t('placeholder.pediatrician-phone')}
            />
          </div>
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.pediatrician-data')}
        </span>
        <div className="form_form-group-field">
          <Field
            name="pediatricianData"
            type="text"
            component="textarea"
            maxLength="200"
            placeholder={t('placeholder.student.pediatrician-data')}
          />
        </div>
      </div>
    </Fragment>
  );
}

MedicalInfo.propTypes = {
  t: PropType.func.isRequired,
};
